import React, { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import PageContainer from "./layout/PageContainer.js";
import JsonLd from "./JsonLd.js";
import GuideCoverHero from "./guide/GuideCoverHero.js";
import GuideTableOfContents from "./guide/GuideTableOfContents.js";
import { BETTER_DECISIONS_GUIDE } from "../constants/betterDecisionsGuide.js";
import { BETTER_DECISIONS_COVER } from "../constants/betterDecisionsGuideVisuals.js";
import { buildGuideJsonLd } from "../utils/guideJsonLd.js";
import "../mental-clarity-guide.css";

const DEFAULT_TITLE = "Ahavibes — Stop reacting. Start thinking clearly.";
const DEFAULT_DESCRIPTION =
  "A guided framework to examine interpretations, reduce mental noise, and make better decisions.";
const PAGE_TITLE = "Better Decisions: A Practical Guide | Ahavibes";

const BetterDecisions = () => {
  const jsonLd = useMemo(() => buildGuideJsonLd(BETTER_DECISIONS_GUIDE), []);

  useEffect(() => {
    document.title = PAGE_TITLE;

    let meta = document.querySelector('meta[name="description"]');
    const createdMeta = !meta;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    const previousDescription = meta.getAttribute("content");
    meta.setAttribute("content", BETTER_DECISIONS_GUIDE.description);

    return () => {
      document.title = DEFAULT_TITLE;
      if (createdMeta) {
        meta.remove();
      } else {
        meta.setAttribute("content", previousDescription || DEFAULT_DESCRIPTION);
      }
    };
  }, []);

  return (
    <>
      <JsonLd data={jsonLd} id="better-decisions-jsonld" />
      <PageContainer size="wide" className="mental-clarity-guide">
        <GuideCoverHero
          headline={BETTER_DECISIONS_GUIDE.headline}
          lead={BETTER_DECISIONS_GUIDE.description}
          cover={BETTER_DECISIONS_COVER}
        />
        <GuideTableOfContents
          sections={BETTER_DECISIONS_GUIDE.sections}
          basePath="/better-decisions"
        />
        <nav className="guide-section-nav" aria-label="Pillar navigation">
          <div className="guide-section-nav__links">
            <Link
              to="/emotional-awareness"
              className="guide-section-nav__link guide-section-nav__link--prev"
            >
              &larr; Previous: Emotional Awareness
            </Link>
            <Link to="/guide" className="guide-section-nav__link guide-section-nav__link--next">
              All Guides &rarr;
            </Link>
          </div>
        </nav>
      </PageContainer>
    </>
  );
};

export default BetterDecisions;
